module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/follow-4373faea1d92aa6a3f85668a52262b17.svg&quot;;"